import React, {Component} from 'react';
import './App.css';
import {ConnectedRouter} from 'connected-react-router';
import {connect} from 'react-redux';
import {
  requestToLogin,
  changeUserAtLoginProperties,
  displayInfoDialogBox,
  displayRejectAuthDialogBox,
} from './actions/user';
import {
  changeSolicitorUsersListSettings,
  changeSolicitorDisplayedUsers,
  solicitorUsersAgentsFilter,
  solicitorUsersPageShift,
} from './actions/agentsList';
import {
  changeNewSolicitorProperties,
  solicitorFormEmailInfo,
  solicitorFormEmailValidationError,
  solicitorFormUsernameInfo,
  solicitorFormUsernameValidationError,
} from './actions/newSolicitor';
import AuthRouter from './routers/authRouter';
import './style/arag.css';
import './style/general.css';
import {
  GoogleReCaptchaProvider
} from 'react-google-recaptcha-v3';


class App extends Component {
  render() {
    return (
      <ConnectedRouter history={this.props.History}>
        <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
          <AuthRouter />
        </GoogleReCaptchaProvider>
      </ConnectedRouter>
    );
  }
}

const mapStateToProps = state => {
  return {
    isAuth: !!state.user.loggedInUser.id,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    userLoginProperties: (userProp, value) => {
      dispatch(changeUserAtLoginProperties(userProp, value));
    },
    displayDialogBox: () => {
      dispatch(displayInfoDialogBox());
    },
    displayAuthDialogBox: () => {
      dispatch(displayRejectAuthDialogBox());
    },
    displaySolicitorFormEmailInfo: () => {
      dispatch(solicitorFormEmailInfo());
    },
    displaySolicitorFormUsernameInfo: () => {
      dispatch(solicitorFormUsernameInfo());
    },
    displaySolicitorFormEmailValidationError: () => {
      dispatch(solicitorFormEmailValidationError());
    },
    displaySolicitorFormUsernameValidationError: () => {
      dispatch(solicitorFormUsernameValidationError());
    },
    newSolicitorProperties: (property, value) => {
      dispatch(changeNewSolicitorProperties(property, value));
    },
    logIn: user => {
      dispatch(requestToLogin(user));
    },
    updateSolicitorsChangedUsers: data => {
      dispatch(changeSolicitorDisplayedUsers(data));
    },
    solicitorDisplaySetting: (settingKey, value) => {
      dispatch(changeSolicitorUsersListSettings(settingKey, value));
    },
    solicitorUsersPagination: direction => {
      dispatch(solicitorUsersPageShift(direction));
    },
    solicitorUsersAgentsFilter: filteredAgents => {
      dispatch(solicitorUsersAgentsFilter(filteredAgents));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
